import {IIncentive} from "../interfaces/incentive";
import {INCENTIVE_IMG_DEFAULT} from "./incentive-img-default.const";

export const INCENTIVE_DEFAULT: IIncentive = {
  id: '',
  branchId: '',
  startDate: '',
  endDate: '',
  noticePageImg: INCENTIVE_IMG_DEFAULT,
  noticePageTitle: 'Faça a pesquisa e participe do sorteio',
  noticePageDescription: 'Todos os dias será sorteado, basta responder a pesquisa você pode ser sorteado',
  winnerPageImg: INCENTIVE_IMG_DEFAULT,
  winnerPageTitle: 'Você foi sorteado!',
  winnerPageDescription: 'procure o gerente e fale o seu número para receber o seu premio'
}
